export default __webpack_public_path__ + "Future-Menus-Report-2025.pdf";